var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 9.375V8.5",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 14.625V15.5",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.483 14C10.71 14.371 11.097 14.628 11.564 14.628H12.002H12.523C13.202 14.628 13.751 14.078 13.751 13.4C13.751 12.836 13.367 12.345 12.821 12.207L11.181 11.795C10.636 11.658 10.251 11.166 10.251 10.602C10.251 9.92302 10.801 9.37402 11.479 9.37402H12H12.438C12.905 9.37402 13.291 9.62902 13.518 9.99902",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.804 18.213V18.213C17.299 17.712 14.715 17.774 12.237 18.393L12 18.453C9.366 19.111 6.619 19.177 3.957 18.644L3.804 18.613C3.336 18.52 3 18.109 3 17.633V6.79402C3 6.16302 3.577 5.69002 4.196 5.81302V5.81302C6.701 6.31402 9.285 6.25202 11.763 5.63302L12.236 5.51502C14.714 4.89602 17.299 4.83402 19.803 5.33502L20.195 5.41302C20.664 5.50702 21 5.91702 21 6.39402V17.233C21 17.864 20.423 18.337 19.804 18.213V18.213Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.d9ab264899fa05b61c18547366fde34c.svg";
export { ForwardRef as ReactComponent };